<template>
	<AsiCardDetail :icon="icons.description" :title="$t('item.longDescription')"
	               :show-action-button="!readonly" :action-button-disabled="disabled" @actionButtonClicked="updateDialog.open()">

		<div class="d-flex justify-center pt-2 pb-4">
			<v-btn-toggle v-model="locale" mandatory>
				<AsiBtn v-for="curLocale in availableLocales" :key="curLocale.value" :value="curLocale.value" small>
					{{ curLocale.text }}
				</AsiBtn>
			</v-btn-toggle>
		</div>
		<v-divider/>
		<v-card-text>
			<AsiMarkDownViewer :value="item.longDescription[currentLocaleExtracted] ?? `*${$t('item.longDescriptionNotSet')}*`"/>
		</v-card-text>

		<ItemUpdateDialogLongDescription v-if="!readonly && updateDialog.isLoaded" :open="updateDialog.isOpen" :item="item"
		                                 @cancel="updateDialog.close()" @save="updateDialog.close(); change();"/>
	</AsiCardDetail>
</template>

<script lang="ts">
	import Vue from 'vue';
	import {Component, Prop, Emit} from 'vue-property-decorator';
	import AsiCardDetail from "@/components/common/AsiCardDetail.vue";
	import Icon from "@/plugins/icons";
	import AsiBtn from "@/components/common/AsiBtn.vue";
	import {IItemAdmin} from "@/models/item/ItemAdminModels";
	import AsiMarkDownViewer from "@/components/common/AsiMarkDownViewer.vue";
	import {TranslateResult} from "vue-i18n";
	import LocaleHelper from "@/helpers/LocaleHelper";
	import DialogHandler from "@/components/common/DialogHandler";
	import ItemUpdateDialogLongDescription from "@/components/item/admin/ItemUpdateDialogLongDescription.vue";

	@Component({
		components: {
			ItemUpdateDialogLongDescription,
			AsiMarkDownViewer, AsiBtn, AsiCardDetail}
	})
	export default class ItemCardLongDescription extends Vue {

		@Prop({type: Object, required: true})
		public item!: IItemAdmin;

		@Prop({type: Boolean, default: false})
		public readonly!: boolean;

		@Prop({type: Boolean, default: false})
		public disabled!: boolean;

		private icons = Icon;
		private locale: string = this.$i18n.locale;
		private updateDialog: DialogHandler = new DialogHandler();

		private get availableLocales(): { text: string | TranslateResult, value: string }[] {
			return LocaleHelper.supportedLocaleOptions();
		}

		private get currentLocaleExtracted(): string {
			return LocaleHelper.extractLanguage(this.locale);
		}

		@Emit('change')
		public change(): void {
			return;
		}
	}
</script>

<style scoped lang="scss">

</style>
